import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import {
  ProfileImage,
  Subject,
  ProfileModuleState,
  SetProfilePhotoPayload,
  SetProfilePhotoAction,
} from "../redux/profile/types";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { companyIcon, personIcon } from "../icons";
import { setProfilePhoto } from "../redux/profile/actions";
import { OptimizedImageUrls } from "../../../component-configuration/optimized-image";

interface ComponentProps {
  isRequired?: boolean;
}

interface MapStateProps {
  profileImage: ProfileImage;
  profileImageUrl: OptimizedImageUrls | null;
  user: Person;
  type: Subject | null;
}

interface MapDispatchProps {
  setProfilePhoto: (payload: SetProfilePhotoPayload) => SetProfilePhotoAction;
}

export type Props = ComponentProps & MapStateProps & MapDispatchProps;

export const Component = (props: Props) => {
  const { profileImage, profileImageUrl, setProfilePhoto, type, isRequired } = props;

  const onFileSelect = (event: any) => {
    const file = event.target?.files && event.target.files[0];
    if (file) setProfilePhoto({ file });
  };

  const placeholderIcon = type === "Person" ? personIcon : type === "Entity" ? companyIcon : null;
  const uploadedProfileImage = profileImage?.dataUrl;
  const existingProfileImage = profileImageUrl?.requestedResolutionUrl;
  const imageUrl = uploadedProfileImage || existingProfileImage;
  const backgroundImage = imageUrl ? { backgroundImage: `url('${imageUrl}')` } : {};

  return (
    <div className="upload-image-bar">
      <div style={{ ...backgroundImage }} className="image-container">
        {!imageUrl && placeholderIcon}
      </div>
      <div className="upload-button">
        <div className="button">
          <span> Choose file</span>
        </div>
        <input type="file" name="file" onChange={onFileSelect} accept="image/png,image/gif,image/jpeg" />
      </div>
      <div className="image-preview">
        <h3 className="label">Profile Picture: {isRequired && "*"}</h3>
        <h4 className="upload-to-see-preview">Choose profile picture file to see preview</h4>
        <div className="upload-file-note">300px x 300px is recommended. JPGs, JPEGs, and PNGs are supported.</div>
      </div>
    </div>
  );
};

const mapState = (state: AppState & ProfileModuleState) => ({
  user: state.account.user,
  profileImage: state.profile.profileImage,
  profileImageUrl: state.profile.profileImageUrl,
  type: state.profile.type,
});

const mapDispatch = {
  setProfilePhoto: setProfilePhoto,
};

export const Logo = connect(mapState, mapDispatch)(Component);
